import type { RealtimePostgresChangesPayload } from "@supabase/supabase-js";
import { supabase } from "../config/supabase";

// Supabase Realtime: the one channel the RFQ list listens on.

export type RealtimeRfqTable = "rfqs" | "rfq_items";

export type RfqChangePayload = RealtimePostgresChangesPayload<Record<string, unknown>>;

export type RealtimeStatus = "SUBSCRIBED" | "TIMED_OUT" | "CLOSED" | "CHANNEL_ERROR";

/**
 * Listen for INSERT, UPDATE and DELETE on `rfqs` and/or `rfq_items` (in that
 * order) on the `rfq-realtime-sync` channel. Every change arrives, the user's
 * own included: `broadcast: { self }` applies to broadcast messages only, not
 * to postgres_changes. Returns the function that removes the channel.
 */
export function subscribeToRfqChanges(
  tables: readonly RealtimeRfqTable[],
  onChange: (payload: RfqChangePayload) => void,
  onStatus: (status: RealtimeStatus) => void,
): () => void {
  const channel = supabase.channel("rfq-realtime-sync");

  for (const table of ["rfqs", "rfq_items"] as const) {
    if (!tables.includes(table)) continue;
    channel.on(
      "postgres_changes",
      {
        event: "*", // INSERT, UPDATE, DELETE
        schema: "public",
        table,
      },
      onChange,
    );
  }

  channel.subscribe((status) => onStatus(status as RealtimeStatus));

  return () => {
    supabase.removeChannel(channel);
  };
}
